export default __webpack_public_path__ + "static/media/plane-departure.9517c05e.svg";